import { LoadingIndicator, LoadingIndicatorLarge } from "../../utility";

const LoadingSpinnerIcon = (props) => {
  const { isLargeSpinner, ...childProps } = props;
  let spinner = <LoadingIndicator {...childProps} />;
  if (isLargeSpinner) {
    spinner = <LoadingIndicatorLarge {...childProps} />;
  }

  return spinner;
};

export default LoadingSpinnerIcon;
